import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

const useStyles = makeStyles(theme => ({
    root: {
        margin:theme.spacing(2,0)
    }
}))

const CustomPagination = (props) => {
    const classes = useStyles()
    const { activePage,
        itemsCountPerPage,
        totalItemsCount,
        pageRangeDisplayed,
        onChange
    } = props;
    const count = Math.ceil((totalItemsCount / itemsCountPerPage));
    const handleChange = (event,page) => {
        onChange(page)
    }
    return (
        <Pagination
            count={count}
            page={activePage}
            boundaryCount={pageRangeDisplayed}
            color="secondary"
            variant="outlined"
            shape="rounded"
            className={classes.root}
            onChange={handleChange}
        />
    )
}

export default CustomPagination
